
/* injects from baggage-loader */

'use strict';

export default class ProjectDonationWizardStep1Controller {

	constructor($log, $state, Countries, Alerts) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.countries = Countries;
		this.Alerts = Alerts;

		this.required_fields = [{
			key: 'first_name',
			name: 'First name'
		}, {
			key: 'last_name',
			name: 'Last name'
		}, {
			key: 'email',
			name: 'Email'
		}, {
			key: 'phone',
			name: 'Phone'
		}, {
			key: 'street_address',
			name: 'Street Address'
		},{
			key: 'country',
			name: 'Country'
		}, {
			key: 'postal_code',
			name: 'Postal Code'
		}]

	}

	$onInit() {

		if (typeof this.donation.billing_address === 'undefined') {
			this.donation.billing_address = {
				country: 'US'
			};
		}

		// Autofill personal info from user profile
		if (this.profile) {
			this.donation.billing_address.first_name = this.profile.first_name;
			this.donation.billing_address.last_name = this.profile.last_name;
			this.donation.billing_address.email = this.profile.email;
			this.donation.billing_address.phone = this.profile.phone;
			this.donation.billing_address.street_address = this.profile.address_line_1;
			this.donation.billing_address.street_address_2 = this.profile.address_line_2;
			this.donation.billing_address.city = this.profile.city;
			this.donation.billing_address.country = this.profile.country;
			this.donation.billing_address.postal_code = this.profile.postal_code;
		}

		// this.$log.log(this.donation);
		// this.$log.log(this.profile)

	}

	nextStep() {

		// Validate inputs
		for (let field of this.required_fields) {
			if (!this.donation.billing_address[field.key]) {
				this.Alerts.setLocal({
					msg: `Please complete out the "${field.name}" field before continuing`,
					type: 'danger'
				});
				return false;
			}
		}
		
		// Passed all validations, continue to next step
		this.$state.go('project-donation-wizard.step2');

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step1/project-donation-wizard.step1.controller.js